import {configureStore} from "@reduxjs/toolkit";
import state from "./reducers/reducers_state";
import config from "./reducers/reducers_config";
import data from "./reducers/reducers_data";
import tokenReducer from "./slices/tokenSlice";
import {contentApi} from "./api/content.api";
import {relationsApi} from "./api/relations.api";
import {searchApi} from "./api/search.api";
import {apiMiddleware} from "./middleware/api.middleware";
import {commerceApi} from "./api/commerce.api";
import {usersApi} from "./api/users.api";

const Store = configureStore({
    reducer: {
        config,
        data,
        state,
        tokens: tokenReducer,
        [contentApi.reducerPath]: contentApi.reducer,
        [relationsApi.reducerPath]: relationsApi.reducer,
        [searchApi.reducerPath]: searchApi.reducer,
        [commerceApi.reducerPath]: commerceApi.reducer,
        [usersApi.reducerPath]: usersApi.reducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware()
            .concat(contentApi.middleware)
            .concat(relationsApi.middleware)
            .concat(searchApi.middleware)
            .concat(commerceApi.middleware)
            .concat(usersApi.middleware)
            .concat(apiMiddleware)
});


export default Store;
